export const SAMPLE_EMPTY_ARRAY = [] as const;

/* prettier-ignore */
export const SAMPLE_ARRAYS = [
	SAMPLE_EMPTY_ARRAY,
	[1, 2],
] as const;
